import angularModule from 'Authentication/angularModule/scripts/authentication_module';
import Auid from 'Auid';
import moment from 'moment-timezone';
import { preSignupValues } from 'TinyEventLogger';

angularModule.factory('SignUpFormHelper', [
    '$injector',

    function factory($injector) {
        const AuthFormHelperMixin = $injector.get('AuthFormHelperMixin');
        const JoinConfig = $injector.get('JoinConfig');
        const AClassAbove = $injector.get('AClassAbove');
        const EventLogger = $injector.get('EventLogger');
        const AuthClient = $injector.get('AuthClient');
        const Locale = $injector.get('Locale');
        const TranslationHelper = $injector.get('TranslationHelper');
        const translationHelper = new TranslationHelper('authentication.sign_up_form');
        const $rootScope = $injector.get('$rootScope');
        const safeApply = $injector.get('safeApply');
        const reactRouterBridge = $injector.get('reactRouterBridge');
        const ClientStorage = $injector.get('ClientStorage');
        const captchaHelper = $injector.get('captchaHelper');

        return AClassAbove.subclass(() => ({
            initialize(scope) {
                this.scope = scope;
                AuthFormHelperMixin.onLink(scope, this._forwardToNextPage.bind(this));
            },

            getConfig(urlPrefix) {
                return JoinConfig.getConfig(urlPrefix).then(urlConfig => this._applyConfig(urlConfig));
            },

            // See JoinConfig#getConfigSync. Returns null when the app config has not loaded yet.
            getConfigSync(urlPrefix) {
                const urlConfig = JoinConfig.getConfigSync(urlPrefix);
                return urlConfig ? this._applyConfig(urlConfig) : null;
            },

            _applyConfig(urlConfig) {
                const scope = this.scope;
                scope.urlConfig = urlConfig;
                scope.signUpCode = urlConfig.signup_code;
                EventLogger.log('viewed_join_form', {
                    sign_up_code: urlConfig.signup_code,
                });
                return urlConfig;
            },

            onForwardToNextPage(fn) {
                this._clientProvidedForwardToNextPage = fn.bind(this);
            },

            submitRegistration(registrationInfo) {
                const scope = this.scope;
                if (!scope.urlConfig) {
                    throw new Error('urlConfig not set.  Call getConfig()');
                }
                const signUpFormHelper = this;
                scope.preventSubmit = true;
                scope.form_errors = {};

                registrationInfo.sign_up_code = scope.signUpCode;
                if (scope.urlConfig.provider) {
                    registrationInfo.provider = scope.urlConfig.provider;
                }

                // If the user has logged events with an anonymous user id,
                // use that id when creating the user
                const auid = Auid.get($rootScope.currentUser);
                if (auid) {
                    registrationInfo.id = auid;
                }

                // pull skip_apply from the query params (if available) and pass up to the server
                const skip_apply = reactRouterBridge.search() && reactRouterBridge.search().skip_apply;
                if (skip_apply) {
                    registrationInfo.skip_apply = skip_apply;
                }

                // pull the user id stored from a referral link (if available) and pass up to the server
                const referredById = ClientStorage.getItem('referredById');
                if (referredById) {
                    registrationInfo.referred_by_id = referredById;
                }

                // set the user's locale
                registrationInfo.pref_locale = Locale.defaultLocaleForSignUpCode(scope.signUpCode);

                // set the user's timezone
                registrationInfo.timezone = moment.tz.guess();

                // add things like which candidates they have seen and liked on marketing pages
                Object.assign(registrationInfo, preSignupValues.allServer());

                EventLogger.log('auth:submit_registration', {
                    provider: registrationInfo.provider,
                    log_to_customerio: true,
                });

                AuthClient.signUp(registrationInfo)
                    .then(
                        user => {
                            // Ng-token auth isn't broadcasting this event for some reason upon successful registration anymore...
                            $rootScope.$broadcast('auth:validation-success', user);

                            const onboardingQuestions = ClientStorage.getItem('onboardingQuestions');
                            if (onboardingQuestions) {
                                EventLogger.log('auth:registration-success', {
                                    onboarding_questions: JSON.parse(onboardingQuestions),
                                    log_to_customerio: true,
                                });
                            }

                            const listener = $rootScope.$on('validation-responder:login-success', () => {
                                listener();
                                signUpFormHelper._forwardToNextPage();
                            });
                            scope.$on('$destroy', listener);

                            // note: don't set preventsubmit to false, we want to keep the form locked while we transition
                        },
                        response => {
                            // If registration failed for whatever reason, reset the captcha because
                            // the tokens have been consumed.
                            captchaHelper.resetCaptcha();
                            scope.preventSubmit = false;

                            scope.form_errors.general =
                                response.data?.error_description || translationHelper.get('server_error');
                        },
                    )
                    .finally(() => {
                        safeApply($rootScope);
                    });
            },

            _forwardToNextPage() {
                if (this._clientProvidedForwardToNextPage) {
                    this._clientProvidedForwardToNextPage();
                }
            },
        }));
    },
]);
